import FormattedMessage from 'I18n/components/FormattedMessage';
import { Image } from 'foundations-components/transitional/components/Image';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Step } from 'signup-constants/Step';
import { AppKey } from '../app/AppKey';
import { updateKeyValue } from '../store/app/action-creators';
import { useTracker } from '../tracking/useTracker';
import { StyledOAuthErrorMessage } from './OAuthButton.styles';
import { Button as SidePanelButton, Root as SidePanelRoot, Text as SidePanelText } from 'signup-components/components/OAuthButton/OAuthButton';
import { OAuthToLogo, OAuthToLogoDisabled, OAuthToText } from './OAuthMapping';
import { OAuthProviders } from './OAuthProviders';
import { useOAuthSignup } from './useOAuthSignup';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OAuthButton = ({
  oauth,
  onClick,
  isLoading = false,
  textOverride
}) => {
  const [shouldRenderErrorMessage, setShouldRenderErrorMessage] = useState(false);
  const Tracker = useTracker();
  const dispatch = useDispatch();
  const onButtonClick = () => {
    Tracker.signupInteraction('click-oauth-button', {
      partner: oauth
    });
    dispatch(updateKeyValue(AppKey.FirstOAuthPartnerClick, oauth));
    if (onClick) {
      onClick();
    } else {
      setShouldRenderErrorMessage(true);
    }
  };
  const {
    oAuthsEnabledByFlowConfig
  } = useOAuthSignup();
  const isAppleEnabled = oAuthsEnabledByFlowConfig[OAuthProviders.Apple];
  const logo = shouldRenderErrorMessage ? OAuthToLogoDisabled[oauth] : OAuthToLogo[oauth];
  const text = textOverride || OAuthToText[oauth];
  const altText = `Image ${oauth}Image`;
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(SidePanelRoot, {
      "data-selenium": 'oauth-container',
      marginBlockStart: "500",
      marginInline: "auto",
      maxInlineSize: "420px",
      paddingInline: "400",
      provider: oauth,
      useBrandColors: false,
      children: /*#__PURE__*/_jsxs(SidePanelButton, {
        "data-selenium": `oauth-button-${oauth}`,
        "data-test-id": `oauth-button-${oauth}`,
        disabled: shouldRenderErrorMessage,
        id: `oauth-button-${oauth}`,
        onClick: onButtonClick,
        children: [logo && /*#__PURE__*/_jsx(Image, {
          alt: altText,
          height: "auto",
          marginInlineStart: '200',
          src: logo,
          width: "18px"
        }), text && /*#__PURE__*/_jsx(SidePanelText, {
          children: isLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
            size: "sm"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: text
          })
        })]
      })
    }), shouldRenderErrorMessage && /*#__PURE__*/_jsxs(StyledOAuthErrorMessage, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `views.${Step.LandingPage}.${oauth}Error`
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `views.${Step.LandingPage}.otherOAuths.${oauth}${
          // eslint-disable-next-line no-nested-ternary
          oauth === OAuthProviders.Microsoft ? isAppleEnabled ? '.withApple' : '.withoutApple' : ''}`
        })
      })]
    })]
  });
};